export default {"src":"/_next/static/media/lab-service.3a4db88d.svg","height":318,"width":284,"blurWidth":0,"blurHeight":0};